/// <reference types="./getPrincipalsTotalCount.d.ts" />
import { ok } from '@dossierhq/core';
import { queryOne } from '../QueryFunctions.js';
export async function authGetPrincipalsTotalCount(database, context) {
    const result = await queryOne(database, context, 'SELECT COUNT(*) as count FROM principals');
    if (result.isError())
        return result;
    return ok(result.value.count);
}
//# sourceMappingURL=getPrincipalsTotalCount.js.map